import React, { useState } from 'react';
import { PageHeader } from '../../components/UI';
import AssetListTab from './tabs/AssetListTab';
import AssetCategoryTab from './tabs/AssetCategoryTab';
import DepreciationTab from './tabs/DepreciationTab';
import MaintenanceTab from './tabs/MaintenanceTab';
import ReportsTab from './tabs/ReportsTab';

const AssetPage = () => {
  const [tab, setTab] = useState('list');

  const tabs = [
    { id: 'list', label: 'Daftar Aset', component: AssetListTab },
    { id: 'category', label: 'Kategori', component: AssetCategoryTab },
    { id: 'depreciation', label: 'Depresiasi', component: DepreciationTab },
    { id: 'maintenance', label: 'Pemeliharaan', component: MaintenanceTab },
    { id: 'reports', label: 'Laporan', component: ReportsTab },
  ];

  const CurrentTab = tabs.find(t => t.id === tab)?.component || AssetListTab;

  return (
    <div>
      <PageHeader title="Manajemen Aset" subtitle="Data dan informasi aset" />
      <div style={{ display: 'flex', gap: 8, marginBottom: 24, borderBottom: '1px solid #E5E7EB', overflowX: 'auto' }}>
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              padding: '12px 16px',
              borderBottom: tab === t.id ? '2px solid #2563EB' : 'none',
              color: tab === t.id ? '#2563EB' : '#6B7280',
              fontWeight: tab === t.id ? 600 : 500,
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      <CurrentTab />
    </div>
  );
};

export default AssetPage;
